import dayjs from 'dayjs';

const EN = {
  header: {
    Home: 'Home',
    News: 'News',
    Manufacture: 'Mold making',
    Product: 'Product display',
    Mall: 'Molds mall',
    Platform: 'Order platform',
    Contact: 'Contact us',
    Wechat: 'Wechat',
    TechnicalStrength: 'Technical Strength',
    CustomerCase: 'Customer Case',
    moldCloud: 'Mold Cloud'
  },
  section: {
    introduce: {
      // companyName:'Zhejiang die fine machine Co., LTD',
      companyName:'Ningbo Daxie Development ZONE Tianzheng MOULD Co., Ltd.',
      more:'Learn more',
      title: 'Company Profile',
      content: 'Ningbo Tianzheng mould Co., Ltd., located in Daxie National Economic Development Zone, Ningbo City, Zhejiang Province, China, was founded in 2000. Since its establishment, the company has specialized in technology and quality. Over the years, it has always focused on the design and manufacture of die-casting molds. The molds designed, developed and produced by the company are mainly for large well-known manufacturers at home and abroad, involving many fields such as auto parts, medical devices, lighting systems and communication products. The products are exported to the whole country, Japan, North America and Europe.',
    },
    products:{
      title:'Product Display',
      subtitle:'COMPANY PRODUCTS',
      more: 'View Details'
    },
    news: 'News Center',
    // honor: 'Corporate honor',
    tags:{
      win:'Cooperation and win-win',
      benefitingAll:'Benefiting all',
      honesty:'Honesty and trustworthiness',
      brandValue:'Brand value'
    },
    honor: {
      title:'Corporate honor',
      more: 'Learn More',
      articleTitle:'National-level specialized, precise, and new "small giant" enterprise',
      content:'With its commitment to quality and sincerity, Ningbo Tianzheng Mould Co., Ltd. defines the benchmark of lean production through continuous innovation and adherence. Through constant development and transformation, it forges a strong backbone for national brands. | As a national-level specialized, precise, and new "small giant" enterprise, Tianzheng Mould is the leading company in China for large-scale magnesium alloy structural parts die casting molds. It possesses core technologies in the design, manufacturing, and production processes of large-scale magnesium alloy molds, as well as the capability to provide full life-cycle management services for molds.'
    },
    qrTips:'Scan QR code on WeChat to follow official account',
    partner: {
      title: 'Major customers',
      firstRow: 'Toyota | GE | Hella',
      secondRow: 'Zhongtai | Honda | Ford',
      thirdRow: 'Peugeot | Aisin | Mercury',
      fourRow: 'Porsche | Mercury | Aisin',
      fifthRow: 'SAIC | Nidec',
    },
    culture: 'Corporate culture',
    newsBlock: {
      more: 'Learn More',
      title: 'News'
    },
    poster: {
      title: 'CHINA'
    },
    CustomerCase: {
      title: 'Customer Case',
      more: 'Learn More'
    }
  },
  footer: {
    blockTitles:{
      about:'About Tianzheng',
      moldManufacturing:'Mold manufacturing',
      friendlyLinks:'Friendly Links',
      contactInformation:'Contact information'
    },
    technology:'Technical research and development',
    quality:'quality assurance',
    deviceSupport:'device support',
    home: 'Home',
    contact: 'Contact us',
    molds: ' Molds mall ',
    order: ' Order platform',
    mail: ' Mailbox',
    business: ' Business',
    license: ' License',
    wx: 'Official wechat',
    phone: 'Phone: ',
    fax: 'Fax: ',
    mailbox: 'Mailbox: tony@tzmc.com',
    website: 'Website: http://www.tzmc.com',
    record: 'Record No.: ',
    copyright: `©${dayjs().year()} Copyright Tianzheng mould Co.,Ltd`,
    news: 'News',
    product: 'Product display',
    customerCase: 'Customer Case',
    power: 'Technical Strength',
    moldCloud: 'Mold Cloud'
  },
  manufacture: {
    title: 'Mold making',
    subtitle: 'Technology | Quality | Equipment | System',
    crumbs: 'Your location',
    technology: 'The company brings together top die-casting technology and mold manufacturing R&D technical personnel at home and abroad, and the talent echelon is solid and stable, united and efficient. The company has successively established multiple design and R&D centers to ensure scientific and effective manufacturing services from mold development and design to mold production and output. There are more than 30 development, design and engineering and technical personnel including overseas engineers. The talent echelon is solid and stable, united and efficient, providing reliable guarantees for mold design and user use and maintenance.',
    quality: 'Strive fo survival on the basis of quality, pursue for the development based on the efficiency.High-precision laser scanning tri-coordinate measuring instrument make a thorough detection to make sure every set of mould Tianzheng produces are of Seiko quality.',
    equipment: 'Through years of moulds producting experience, the company has cleared up and completed a set of work process corresponding to "TZMC" characteristic manufacture and managment demand, so as to make every set of moulds making have optimal manufacture lines an operation instructions.Tianzheng moulds have been equipped with a set of world-class precision mould manufacturing equipment.',
    system: 'Tianzheng mould introduces E-man production management system and APS production scheduling system to realize informatization, refinement and flow of production management, shorten mould production cycle and enhance cost management ability.',
    team: {
      title: 'Quality assurance R&D team',
      content: 'The company brings together top die-casting technology and mold manufacturing R&D technical personnel at home and abroad, and the talent echelon is solid and stable, united and efficient. The company has successively established multiple design and R&D centers to ensure scientific and effective manufacturing services from mold development and design to mold production and output. There are more than 40 development, design and engineering and technical personnel including overseas engineers. The talent echelon is solid and stable, united and efficient, providing reliable guarantees for mold design and user use and maintenance.',
      technicalPersonnel: 'Technicians',
      undergraduateDegree: 'Bachelor’s Degree',
      developmentCenter: 'Design and Research Center',
      GenuineDesignSoftware: 'Genuine Design Software'
    },
    patent: {
      companyName: 'T·Z·M·C',
      slogan: 'Quality Lays the Foundation, Patents Lead the Way, Honors Bear Witness',
      subSlogan: 'Quality Lays the Foundation, Patents Lead the Way, Honors Bear Witness'
    },
    equipments: {
      title: 'High-Precision Equipment for High-Quality Products',
      content: 'Tianzheng Molds places quality and efficiency at its core, equipped with world-class precision mold processing equipment and imported high-speed machining centers with micron-level accuracy. This enables us to meet customers\' high-precision requirements for molds. Additionally, the company has introduced high-precision laser scanning coordinate measuring machines for comprehensive inspections, ensuring that every mold meets the highest standards of precision. Years of production experience have led to the development of a workflow tailored to our unique characteristics, providing the best process routes and work instructions for mold manufacturing.',
      MeasuringInstrument: 'High-Precision Laser Scanning CMM',
      MachiningCenter: 'Micron-level High-speed Machining Center'
    },
    systems: {
      title: 'Tianzheng Mold introduced E-MAN production management system and APS scheduling system',
      ProductionManagement: {
        title: 'Production Management',
        desc: 'Informationization integration and visual display, to achieve informationization, refinement and process of production management.'
      },

      ProductionCycle: {
        title: 'Production Cycle',
        desc: 'Optimize the production plan, monitor the production progress in real time, shorten the mold production cycle.'
      },

      ManagementCosts: {
        title: 'Management Costs',
        desc: 'Reduce losses by optimizing production processes and reduce fixed costs by rationally arranging production batches.'
      }
    }
  },
  contact: {
    title: 'Contact us',
    business: {
      title: 'Business contact',
      domestic: 'Domestic',
      international: 'International'
    },
    technology: {
      title: 'Technical connection',
      Daxie: 'Daxie Technology Department',
      Beilun: 'Beilun Technology Department'
    },
    location: '5 Beidu Road, Daxie Development Zone, Ningbo, Zhejiang',
    tab: {
      business: 'Business Cooperation',
      job: 'Talent Recruitment'
    },
    job: {
      title: 'Recruitment Position',
      SocialRecruitment: 'Social Recruitment',
      CampusRecruitment: 'Campus Recruitment',
      search: 'Please enter position',
      Duty: 'Job Responsibility',
      JobRequirements: 'Job Requirements',
      TreatmentAndWelfare: 'Treatment And Welfare',
      numberRecruitsUnit: 'people',
      resume: 'Send your resume',
      uploadResume: 'Upload Resume',
      cancel: 'cancel',
      confirm: 'submit',
      uploadFail: 'Upload Fail',
      uploadSuccess: 'Upload Success',
      emptyDesc: 'No Data'
    },
    contact: {
      phone: 'Phone',
      fax: 'Fax',
      email: 'Mailbox',
      address: 'Address'
    }
  },
  content:{
    News: 'News',
    Company: 'Company',
    Industry: 'Industry',
    More: 'More',
    NewsCenter: 'News Center',
    Location: 'Your location',
    All: 'All',
    Productdisplay: 'Product display',
    Molds: 'Mold',
    Products: 'Product',
    Mold: 'Mold',
    Schimmel: 'Schimmel',
    Parts: 'automobile parts',
    Machinery: 'General Machinery',
    Other: 'other',
    TechnicalStrength: 'Technical Strength'
  },
  news: {
    createTime: 'created: '
  },
  companyDesc: {
    FoundingDate: 'Founding Date',
    Employees: 'Company Employees',
    Customer: 'Customer',
    FoundingDateUnit: 'AD'
  },
  notFound: {
    message: 'The page you are looking for does not exist!!!',
    tips: 'Please check that the URL you entered is correct, or click the button below to return to the homepage.',
    backHome: 'Back to home'
  },
  customerService: 'Customer Service'
}

export default EN